import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建总部员工
export const CREATE_ACCOUNT_HEADQUARTERS_STAFF = gql`
    mutation CreateAccountHeadquartersStaff($input: AccountHeadquartersStaffInput!) {
        createAccountHeadquartersStaff(input: $input)
    }
`;

// 更新总部员工
export const UPDATE_ACCOUNT_HEADQUARTERS_STAFF = gql`
    mutation UpdateAccountHeadquartersStaff($input: AccountHeadquartersStaffInput!) {
        updateAccountHeadquartersStaff(input: $input)
    }
`;

export interface AccountHeadquartersStaffInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
}

export const createAccountHeadquartersStaff = async (input: AccountHeadquartersStaffInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_HEADQUARTERS_STAFF,
        variables: {input}
    });
    return data.createAccountHeadquartersStaff;
};

export const updateAccountHeadquartersStaff = async (input: AccountHeadquartersStaffInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_HEADQUARTERS_STAFF,
        variables: {input}
    });
    return data.updateAccountHeadquartersStaff;
};  